/* eslint-disable sonarjs/no-duplicate-string */
import { Address } from "@hermes/api-model-address";
import { CountryCode } from "@hermes/locale";

// COUNTRY CODE

interface CountryData {
    code: string;
    label: string; // Label in the country local
    i18nLabel: string; // Label in the current local (translated)
}

/**
 * Country list with the right translation.
 *
 * @return array
 * Set a array with country_code & label
 */
export const countries: CountryData[] = [
    {
        code: "CN",
        label: "中国内地",
        i18nLabel: $localize`:@@hermes_country_cn:中国内地`,
    },
    {
        code: "TW",
        label: "臺灣地區",
        i18nLabel: $localize`:@@hermes_country_tw:臺灣地區`,
    },
    {
        code: "JP",
        label: "日本",
        i18nLabel: $localize`:@@hermes_country_jp:日本`,
    },
    {
        code: "AX",
        label: "Åland Islands",
        i18nLabel: $localize`:@@hermes_country_ax:Åland Islands`,
    },
    {
        code: "AT",
        label: "Österreich",
        i18nLabel: $localize`:@@hermes_country_at:Österreich`,
    },
    {
        code: "AF",
        label: "Afghanistan",
        i18nLabel: $localize`:@@hermes_country_af:Afghanistan`,
    },
    {
        code: "AL",
        label: "Albania",
        i18nLabel: $localize`:@@hermes_country_al:Albania`,
    },
    {
        code: "DZ",
        label: "Algeria",
        i18nLabel: $localize`:@@hermes_country_dz:Algeria`,
    },
    {
        code: "AS",
        label: "American Samoa",
        i18nLabel: $localize`:@@hermes_country_as:American Samoa`,
    },
    {
        code: "AD",
        label: "Andorra",
        i18nLabel: $localize`:@@hermes_country_ad:Andorra`,
    },
    {
        code: "AO",
        label: "Angola",
        i18nLabel: $localize`:@@hermes_country_ao:Angola`,
    },
    {
        code: "AI",
        label: "Anguilla",
        i18nLabel: $localize`:@@hermes_country_ai:Anguilla`,
    },
    {
        code: "AQ",
        label: "Antarctica",
        i18nLabel: $localize`:@@hermes_country_aq:Antarctica`,
    },
    {
        code: "AG",
        label: "Antigua and Barbuda",
        i18nLabel: $localize`:@@hermes_country_ag:Antigua and Barbuda`,
    },
    {
        code: "AR",
        label: "Argentina",
        i18nLabel: $localize`:@@hermes_country_ar:Argentina`,
    },
    {
        code: "AM",
        label: "Armenia",
        i18nLabel: $localize`:@@hermes_country_am:Armenia`,
    },
    {
        code: "AW",
        label: "Aruba",
        i18nLabel: $localize`:@@hermes_country_aw:Aruba`,
    },
    {
        code: "AU",
        label: "Australia",
        i18nLabel: $localize`:@@hermes_country_au:Australia`,
    },
    {
        code: "AZ",
        label: "Azerbaijan",
        i18nLabel: $localize`:@@hermes_country_az:Azerbaijan`,
    },
    {
        code: "BS",
        label: "Bahamas",
        i18nLabel: $localize`:@@hermes_country_bs:Bahamas`,
    },
    {
        code: "BH",
        label: "Bahrain",
        i18nLabel: $localize`:@@hermes_country_bh:Bahrain`,
    },
    {
        code: "BD",
        label: "Bangladesh",
        i18nLabel: $localize`:@@hermes_country_bd:Bangladesh`,
    },
    {
        code: "BB",
        label: "Barbados",
        i18nLabel: $localize`:@@hermes_country_bb:Barbados`,
    },
    {
        code: "BY",
        label: "Belarus",
        i18nLabel: $localize`:@@hermes_country_by:Belarus`,
    },
    {
        code: "BE",
        label: "Belgium",
        i18nLabel: $localize`:@@hermes_country_be:Belgium`,
    },
    {
        code: "BZ",
        label: "Belize",
        i18nLabel: $localize`:@@hermes_country_bz:Belize`,
    },
    {
        code: "BJ",
        label: "Benin",
        i18nLabel: $localize`:@@hermes_country_bj:Benin`,
    },
    {
        code: "BM",
        label: "Bermuda",
        i18nLabel: $localize`:@@hermes_country_bm:Bermuda`,
    },
    {
        code: "BT",
        label: "Bhutan",
        i18nLabel: $localize`:@@hermes_country_bt:Bhutan`,
    },
    {
        code: "BO",
        label: "Bolivia, Plurinational State of",
        i18nLabel: $localize`:@@hermes_country_bo:Bolivia, Plurinational State of`,
    },
    {
        code: "BA",
        label: "Bosnia and Herzegovina",
        i18nLabel: $localize`:@@hermes_country_ba:Bosnia and Herzegovina`,
    },
    {
        code: "BW",
        label: "Botswana",
        i18nLabel: $localize`:@@hermes_country_bw:Botswana`,
    },
    {
        code: "BV",
        label: "Bouvet Island",
        i18nLabel: $localize`:@@hermes_country_bv:Bouvet Island`,
    },
    {
        code: "BR",
        label: "Brazil",
        i18nLabel: $localize`:@@hermes_country_br:Brazil`,
    },
    {
        code: "IO",
        label: "British Indian Ocean Territory",
        i18nLabel: $localize`:@@hermes_country_io:British Indian Ocean Territory`,
    },
    {
        code: "BN",
        label: "Brunei Darussalam",
        i18nLabel: $localize`:@@hermes_country_bn:Brunei Darussalam`,
    },
    {
        code: "BG",
        label: "Bulgaria",
        i18nLabel: $localize`:@@hermes_country_bg:Bulgaria`,
    },
    {
        code: "BF",
        label: "Burkina Faso",
        i18nLabel: $localize`:@@hermes_country_bf:Burkina Faso`,
    },
    {
        code: "BI",
        label: "Burundi",
        i18nLabel: $localize`:@@hermes_country_bi:Burundi`,
    },
    {
        code: "KH",
        label: "Cambodia",
        i18nLabel: $localize`:@@hermes_country_kh:Cambodia`,
    },
    {
        code: "CM",
        label: "Cameroon",
        i18nLabel: $localize`:@@hermes_country_cm:Cameroon`,
    },
    {
        code: "CA",
        label: "Canada",
        i18nLabel: $localize`:@@hermes_country_ca:Canada`,
    },
    {
        code: "CV",
        label: "Cape Verde",
        i18nLabel: $localize`:@@hermes_country_cv:Cape Verde`,
    },
    {
        code: "KY",
        label: "Cayman Islands",
        i18nLabel: $localize`:@@hermes_country_ky:Cayman Islands`,
    },
    {
        code: "CF",
        label: "Central African Republic",
        i18nLabel: $localize`:@@hermes_country_cf:Central African Republic`,
    },
    {
        code: "TD",
        label: "Chad",
        i18nLabel: $localize`:@@hermes_country_td:Chad`,
    },
    {
        code: "CL",
        label: "Chile",
        i18nLabel: $localize`:@@hermes_country_cl:Chile`,
    },
    {
        code: "CX",
        label: "Christmas Island",
        i18nLabel: $localize`:@@hermes_country_cx:Christmas Island`,
    },
    {
        code: "CC",
        label: "Cocos (Keeling) Islands",
        i18nLabel: $localize`:@@hermes_country_cc:Cocos (Keeling) Islands`,
    },
    {
        code: "CO",
        label: "Colombia",
        i18nLabel: $localize`:@@hermes_country_co:Colombia`,
    },
    {
        code: "KM",
        label: "Comoros",
        i18nLabel: $localize`:@@hermes_country_km:Comoros`,
    },
    {
        code: "CG",
        label: "Congo",
        i18nLabel: $localize`:@@hermes_country_cg:Congo`,
    },
    {
        code: "CD",
        label: "Congo, the Democratic Republic of the",
        i18nLabel: $localize`:@@hermes_country_cd:Congo, the Democratic Republic of the`,
    },
    {
        code: "CK",
        label: "Cook Islands",
        i18nLabel: $localize`:@@hermes_country_ck:Cook Islands`,
    },
    {
        code: "CR",
        label: "Costa Rica",
        i18nLabel: $localize`:@@hermes_country_cr:Costa Rica`,
    },
    {
        code: "CI",
        label: "Côte d'Ivoire",
        i18nLabel: $localize`:@@hermes_country_ci:Côte d'Ivoire`,
    },
    {
        code: "HR",
        label: "Croatia",
        i18nLabel: $localize`:@@hermes_country_hr:Croatia`,
    },
    {
        code: "CU",
        label: "Cuba",
        i18nLabel: $localize`:@@hermes_country_cu:Cuba`,
    },
    {
        code: "CY",
        label: "Cyprus",
        i18nLabel: $localize`:@@hermes_country_cy:Cyprus`,
    },
    {
        code: "CZ",
        label: "Czech Republic",
        i18nLabel: $localize`:@@hermes_country_cz:Czech Republic`,
    },
    {
        code: "DK",
        label: "Denmark",
        i18nLabel: $localize`:@@hermes_country_dk:Denmark`,
    },
    {
        code: "DE",
        label: "Deutschland",
        i18nLabel: $localize`:@@hermes_country_de:Deutschland`,
    },
    {
        code: "DJ",
        label: "Djibouti",
        i18nLabel: $localize`:@@hermes_country_dj:Djibouti`,
    },
    {
        code: "DM",
        label: "Dominica",
        i18nLabel: $localize`:@@hermes_country_dm:Dominica`,
    },
    {
        code: "DO",
        label: "Dominican Republic",
        i18nLabel: $localize`:@@hermes_country_do:Dominican Republic`,
    },
    {
        code: "EC",
        label: "Ecuador",
        i18nLabel: $localize`:@@hermes_country_ec:Ecuador`,
    },
    {
        code: "EG",
        label: "Egypt",
        i18nLabel: $localize`:@@hermes_country_eg:Egypt`,
    },
    {
        code: "SV",
        label: "El Salvador",
        i18nLabel: $localize`:@@hermes_country_sv:El Salvador`,
    },
    {
        code: "GQ",
        label: "Equatorial Guinea",
        i18nLabel: $localize`:@@hermes_country_gq:Equatorial Guinea`,
    },
    {
        code: "ER",
        label: "Eritrea",
        i18nLabel: $localize`:@@hermes_country_er:Eritrea`,
    },
    {
        code: "ES",
        label: "España",
        i18nLabel: $localize`:@@hermes_country_es:España`,
    },
    {
        code: "EE",
        label: "Estonia",
        i18nLabel: $localize`:@@hermes_country_ee:Estonia`,
    },
    {
        code: "ET",
        label: "Ethiopia",
        i18nLabel: $localize`:@@hermes_country_et:Ethiopia`,
    },
    {
        code: "FK",
        label: "Falkland Islands (Malvinas)",
        i18nLabel: $localize`:@@hermes_country_fk:Falkland Islands (Malvinas)`,
    },
    {
        code: "FO",
        label: "Faroe Islands",
        i18nLabel: $localize`:@@hermes_country_fo:Faroe Islands`,
    },
    {
        code: "FJ",
        label: "Fiji",
        i18nLabel: $localize`:@@hermes_country_fj:Fiji`,
    },
    {
        code: "FI",
        label: "Finland",
        i18nLabel: $localize`:@@hermes_country_fi:Finland`,
    },
    {
        code: "FR",
        label: "France",
        i18nLabel: $localize`:@@hermes_country_fr:France`,
    },
    {
        code: "GF",
        label: "French Guiana",
        i18nLabel: $localize`:@@hermes_country_gf:French Guiana`,
    },
    {
        code: "PF",
        label: "French Polynesia",
        i18nLabel: $localize`:@@hermes_country_pf:French Polynesia`,
    },
    {
        code: "TF",
        label: "French Southern Territories",
        i18nLabel: $localize`:@@hermes_country_tf:French Southern Territories`,
    },
    {
        code: "GA",
        label: "Gabon",
        i18nLabel: $localize`:@@hermes_country_ga:Gabon`,
    },
    {
        code: "GM",
        label: "Gambia",
        i18nLabel: $localize`:@@hermes_country_gm:Gambia`,
    },
    {
        code: "GE",
        label: "Georgia",
        i18nLabel: $localize`:@@hermes_country_ge:Georgia`,
    },
    {
        code: "GH",
        label: "Ghana",
        i18nLabel: $localize`:@@hermes_country_gh:Ghana`,
    },
    {
        code: "GI",
        label: "Gibraltar",
        i18nLabel: $localize`:@@hermes_country_gi:Gibraltar`,
    },
    {
        code: "GR",
        label: "Greece",
        i18nLabel: $localize`:@@hermes_country_gr:Greece`,
    },
    {
        code: "GL",
        label: "Greenland",
        i18nLabel: $localize`:@@hermes_country_gl:Greenland`,
    },
    {
        code: "GD",
        label: "Grenada",
        i18nLabel: $localize`:@@hermes_country_gd:Grenada`,
    },
    {
        code: "GP",
        label: "Guadeloupe",
        i18nLabel: $localize`:@@hermes_country_gp:Guadeloupe`,
    },
    {
        code: "GU",
        label: "Guam",
        i18nLabel: $localize`:@@hermes_country_gu:Guam`,
    },
    {
        code: "GT",
        label: "Guatemala",
        i18nLabel: $localize`:@@hermes_country_gt:Guatemala`,
    },
    {
        code: "GG",
        label: "Guernsey",
        i18nLabel: $localize`:@@hermes_country_gg:Guernsey`,
    },
    {
        code: "GN",
        label: "Guinea",
        i18nLabel: $localize`:@@hermes_country_gn:Guinea`,
    },
    {
        code: "GW",
        label: "Guinea-Bissau",
        i18nLabel: $localize`:@@hermes_country_gw:Guinea-Bissau`,
    },
    {
        code: "GY",
        label: "Guyana",
        i18nLabel: $localize`:@@hermes_country_gy:Guyana`,
    },
    {
        code: "HT",
        label: "Haiti",
        i18nLabel: $localize`:@@hermes_country_ht:Haiti`,
    },
    {
        code: "HM",
        label: "Heard Island and McDonald Islands",
        i18nLabel: $localize`:@@hermes_country_hm:Heard Island and McDonald Islands`,
    },
    {
        code: "VA",
        label: "Holy See (Vatican City State)",
        i18nLabel: $localize`:@@hermes_country_va:Holy See (Vatican City State)`,
    },
    {
        code: "HN",
        label: "Honduras",
        i18nLabel: $localize`:@@hermes_country_hn:Honduras`,
    },
    {
        code: "HK",
        label: "Hong Kong SAR",
        i18nLabel: $localize`:@@hermes_country_hk:Hong Kong SAR`,
    },
    {
        code: "HU",
        label: "Hungary",
        i18nLabel: $localize`:@@hermes_country_hu:Hungary`,
    },
    {
        code: "IS",
        label: "Iceland",
        i18nLabel: $localize`:@@hermes_country_is:Iceland`,
    },
    {
        code: "IN",
        label: "India",
        i18nLabel: $localize`:@@hermes_country_in:India`,
    },
    {
        code: "ID",
        label: "Indonesia",
        i18nLabel: $localize`:@@hermes_country_id:Indonesia`,
    },
    {
        code: "IR",
        label: "Iran, Islamic Republic of",
        i18nLabel: $localize`:@@hermes_country_ir:Iran, Islamic Republic of`,
    },
    {
        code: "IQ",
        label: "Iraq",
        i18nLabel: $localize`:@@hermes_country_iq:Iraq`,
    },
    {
        code: "IE",
        label: "Ireland",
        i18nLabel: $localize`:@@hermes_country_ie:Ireland`,
    },
    {
        code: "IM",
        label: "Isle of Man",
        i18nLabel: $localize`:@@hermes_country_im:Isle of Man`,
    },
    {
        code: "IL",
        label: "Israel",
        i18nLabel: $localize`:@@hermes_country_il:Israel`,
    },
    {
        code: "IT",
        label: "Italia",
        i18nLabel: $localize`:@@hermes_country_it:Italia`,
    },
    {
        code: "JM",
        label: "Jamaica",
        i18nLabel: $localize`:@@hermes_country_jm:Jamaica`,
    },
    {
        code: "JE",
        label: "Jersey",
        i18nLabel: $localize`:@@hermes_country_je:Jersey`,
    },
    {
        code: "JO",
        label: "Jordan",
        i18nLabel: $localize`:@@hermes_country_jo:Jordan`,
    },
    {
        code: "KZ",
        label: "Kazakhstan",
        i18nLabel: $localize`:@@hermes_country_kz:Kazakhstan`,
    },
    {
        code: "KE",
        label: "Kenya",
        i18nLabel: $localize`:@@hermes_country_ke:Kenya`,
    },
    {
        code: "KI",
        label: "Kiribati",
        i18nLabel: $localize`:@@hermes_country_ki:Kiribati`,
    },
    {
        code: "KP",
        label: "Korea, Democratic People's Republic of",
        i18nLabel: $localize`:@@hermes_country_kp:Korea, Democratic People's Republic of`,
    },
    {
        code: "KR",
        label: "South Korea",
        i18nLabel: $localize`:@@hermes_country_kr:South Korea`,
    },
    {
        code: "KW",
        label: "Kuwait",
        i18nLabel: $localize`:@@hermes_country_kw:Kuwait`,
    },
    {
        code: "KG",
        label: "Kyrgyzstan",
        i18nLabel: $localize`:@@hermes_country_kg:Kyrgyzstan`,
    },
    {
        code: "LA",
        label: "Lao People's Democratic Republic",
        i18nLabel: $localize`:@@hermes_country_la:Lao People's Democratic Republic`,
    },
    {
        code: "LV",
        label: "Latvia",
        i18nLabel: $localize`:@@hermes_country_lv:Latvia`,
    },
    {
        code: "LB",
        label: "Lebanon",
        i18nLabel: $localize`:@@hermes_country_lb:Lebanon`,
    },
    {
        code: "LS",
        label: "Lesotho",
        i18nLabel: $localize`:@@hermes_country_ls:Lesotho`,
    },
    {
        code: "LR",
        label: "Liberia",
        i18nLabel: $localize`:@@hermes_country_lr:Liberia`,
    },
    {
        code: "LY",
        label: "Libya",
        i18nLabel: $localize`:@@hermes_country_ly:Libya`,
    },
    {
        code: "LI",
        label: "Liechtenstein",
        i18nLabel: $localize`:@@hermes_country_li:Liechtenstein`,
    },
    {
        code: "LT",
        label: "Lithuania",
        i18nLabel: $localize`:@@hermes_country_lt:Lithuania`,
    },
    {
        code: "LU",
        label: "Luxembourg",
        i18nLabel: $localize`:@@hermes_country_lu:Luxembourg`,
    },
    {
        code: "MO",
        label: "Macau SAR",
        i18nLabel: $localize`:@@hermes_country_mo:Macau SAR`,
    },
    {
        code: "MK",
        label: "Macedonia, the Former Yugoslav Republic of",
        i18nLabel: $localize`:@@hermes_country_mk:Macedonia, the Former Yugoslav Republic of`,
    },
    {
        code: "MG",
        label: "Madagascar",
        i18nLabel: $localize`:@@hermes_country_mg:Madagascar`,
    },
    {
        code: "MW",
        label: "Malawi",
        i18nLabel: $localize`:@@hermes_country_mw:Malawi`,
    },
    {
        code: "MY",
        label: "Malaysia",
        i18nLabel: $localize`:@@hermes_country_my:Malaysia`,
    },
    {
        code: "MV",
        label: "Maldives",
        i18nLabel: $localize`:@@hermes_country_mv:Maldives`,
    },
    {
        code: "ML",
        label: "Mali",
        i18nLabel: $localize`:@@hermes_country_ml:Mali`,
    },
    {
        code: "MT",
        label: "Malta",
        i18nLabel: $localize`:@@hermes_country_mt:Malta`,
    },
    {
        code: "MH",
        label: "Marshall Islands",
        i18nLabel: $localize`:@@hermes_country_mh:Marshall Islands`,
    },
    {
        code: "MQ",
        label: "Martinique",
        i18nLabel: $localize`:@@hermes_country_mq:Martinique`,
    },
    {
        code: "MR",
        label: "Mauritania",
        i18nLabel: $localize`:@@hermes_country_mr:Mauritania`,
    },
    {
        code: "MU",
        label: "Mauritius",
        i18nLabel: $localize`:@@hermes_country_mu:Mauritius`,
    },
    {
        code: "YT",
        label: "Mayotte",
        i18nLabel: $localize`:@@hermes_country_yt:Mayotte`,
    },
    {
        code: "MX",
        label: "Mexico",
        i18nLabel: $localize`:@@hermes_country_mx:Mexico`,
    },
    {
        code: "FM",
        label: "Micronesia, Federated States of",
        i18nLabel: $localize`:@@hermes_country_fm:Micronesia, Federated States of`,
    },
    {
        code: "MD",
        label: "Moldova, Republic of",
        i18nLabel: $localize`:@@hermes_country_md:Moldova, Republic of`,
    },
    {
        code: "MC",
        label: "Monaco",
        i18nLabel: $localize`:@@hermes_country_mc:Monaco`,
    },
    {
        code: "MN",
        label: "Mongolia",
        i18nLabel: $localize`:@@hermes_country_mn:Mongolia`,
    },
    {
        code: "ME",
        label: "Montenegro",
        i18nLabel: $localize`:@@hermes_country_me:Montenegro`,
    },
    {
        code: "MS",
        label: "Montserrat",
        i18nLabel: $localize`:@@hermes_country_ms:Montserrat`,
    },
    {
        code: "MA",
        label: "Morocco",
        i18nLabel: $localize`:@@hermes_country_ma:Morocco`,
    },
    {
        code: "MZ",
        label: "Mozambique",
        i18nLabel: $localize`:@@hermes_country_mz:Mozambique`,
    },
    {
        code: "MM",
        label: "Myanmar",
        i18nLabel: $localize`:@@hermes_country_mm:Myanmar`,
    },
    {
        code: "NA",
        label: "Namibia",
        i18nLabel: $localize`:@@hermes_country_na:Namibia`,
    },
    {
        code: "NR",
        label: "Nauru",
        i18nLabel: $localize`:@@hermes_country_nr:Nauru`,
    },
    {
        code: "NP",
        label: "Nepal",
        i18nLabel: $localize`:@@hermes_country_np:Nepal`,
    },
    {
        code: "NL",
        label: "Netherlands",
        i18nLabel: $localize`:@@hermes_country_nl:Netherlands`,
    },
    {
        code: "AN",
        label: "Netherlands Antilles",
        i18nLabel: $localize`:@@hermes_country_an:Netherlands Antilles`,
    },
    {
        code: "NC",
        label: "New Caledonia",
        i18nLabel: $localize`:@@hermes_country_nc:New Caledonia`,
    },
    {
        code: "NZ",
        label: "New Zealand",
        i18nLabel: $localize`:@@hermes_country_nz:New Zealand`,
    },
    {
        code: "NI",
        label: "Nicaragua",
        i18nLabel: $localize`:@@hermes_country_ni:Nicaragua`,
    },
    {
        code: "NE",
        label: "Niger",
        i18nLabel: $localize`:@@hermes_country_ne:Niger`,
    },
    {
        code: "NG",
        label: "Nigeria",
        i18nLabel: $localize`:@@hermes_country_ng:Nigeria`,
    },
    {
        code: "NU",
        label: "Niue",
        i18nLabel: $localize`:@@hermes_country_nu:Niue`,
    },
    {
        code: "NF",
        label: "Norfolk Island",
        i18nLabel: $localize`:@@hermes_country_nf:Norfolk Island`,
    },
    {
        code: "MP",
        label: "Northern Mariana Islands",
        i18nLabel: $localize`:@@hermes_country_mp:Northern Mariana Islands`,
    },
    {
        code: "NO",
        label: "Norway",
        i18nLabel: $localize`:@@hermes_country_no:Norway`,
    },
    {
        code: "OM",
        label: "Oman",
        i18nLabel: $localize`:@@hermes_country_om:Oman`,
    },
    {
        code: "PK",
        label: "Pakistan",
        i18nLabel: $localize`:@@hermes_country_pk:Pakistan`,
    },
    {
        code: "PW",
        label: "Palau",
        i18nLabel: $localize`:@@hermes_country_pw:Palau`,
    },
    {
        code: "PS",
        label: "Palestinian Territory",
        i18nLabel: $localize`:@@hermes_country_ps:Palestinian Territory`,
    },
    {
        code: "PA",
        label: "Panama",
        i18nLabel: $localize`:@@hermes_country_pa:Panama`,
    },
    {
        code: "PG",
        label: "Papua New Guinea",
        i18nLabel: $localize`:@@hermes_country_pg:Papua New Guinea`,
    },
    {
        code: "PY",
        label: "Paraguay",
        i18nLabel: $localize`:@@hermes_country_py:Paraguay`,
    },
    {
        code: "PE",
        label: "Peru",
        i18nLabel: $localize`:@@hermes_country_pe:Peru`,
    },
    {
        code: "PH",
        label: "Philippines",
        i18nLabel: $localize`:@@hermes_country_ph:Philippines`,
    },
    {
        code: "PN",
        label: "Pitcairn",
        i18nLabel: $localize`:@@hermes_country_pn:Pitcairn`,
    },
    {
        code: "PL",
        label: "Poland",
        i18nLabel: $localize`:@@hermes_country_pl:Poland`,
    },
    {
        code: "PT",
        label: "Portugal",
        i18nLabel: $localize`:@@hermes_country_pt:Portugal`,
    },
    {
        code: "PR",
        label: "Puerto Rico",
        i18nLabel: $localize`:@@hermes_country_pr:Puerto Rico`,
    },
    {
        code: "QA",
        label: "Qatar",
        i18nLabel: $localize`:@@hermes_country_qa:Qatar`,
    },
    {
        code: "RE",
        label: "Réunion",
        i18nLabel: $localize`:@@hermes_country_re:Réunion`,
    },
    {
        code: "RO",
        label: "Romania",
        i18nLabel: $localize`:@@hermes_country_ro:Romania`,
    },
    {
        code: "RU",
        label: "Russian Federation",
        i18nLabel: $localize`:@@hermes_country_ru:Russian Federation`,
    },
    {
        code: "RW",
        label: "Rwanda",
        i18nLabel: $localize`:@@hermes_country_rw:Rwanda`,
    },
    {
        code: "BL",
        label: "Saint Barthélemy",
        i18nLabel: $localize`:@@hermes_country_bl:Saint Barthélemy`,
    },
    {
        code: "SH",
        label: "Saint Helena, Ascension and Tristan da Cunha",
        i18nLabel: $localize`:@@hermes_country_sh:Saint Helena, Ascension and Tristan da Cunha`,
    },
    {
        code: "KN",
        label: "Saint Kitts and Nevis",
        i18nLabel: $localize`:@@hermes_country_kn:Saint Kitts and Nevis`,
    },
    {
        code: "LC",
        label: "Saint Lucia",
        i18nLabel: $localize`:@@hermes_country_lc:Saint Lucia`,
    },
    {
        code: "MF",
        label: "Saint Martin (French part)",
        i18nLabel: $localize`:@@hermes_country_mf:Saint Martin (French part)`,
    },
    {
        code: "PM",
        label: "Saint Pierre and Miquelon",
        i18nLabel: $localize`:@@hermes_country_pm:Saint Pierre and Miquelon`,
    },
    {
        code: "VC",
        label: "Saint Vincent and the Grenadines",
        i18nLabel: $localize`:@@hermes_country_vc:Saint Vincent and the Grenadines`,
    },
    {
        code: "WS",
        label: "Samoa",
        i18nLabel: $localize`:@@hermes_country_ws:Samoa`,
    },
    {
        code: "SM",
        label: "San Marino",
        i18nLabel: $localize`:@@hermes_country_sm:San Marino`,
    },
    {
        code: "ST",
        label: "Sao Tome and Principe",
        i18nLabel: $localize`:@@hermes_country_st:Sao Tome and Principe`,
    },
    {
        code: "SA",
        label: "Saudi Arabia",
        i18nLabel: $localize`:@@hermes_country_sa:Saudi Arabia`,
    },
    {
        code: "RI",
        label: "Saudi Arabia",
        i18nLabel: $localize`:@@hermes_country_ri:Saudi Arabia`,
    },
    {
        code: "SN",
        label: "Senegal",
        i18nLabel: $localize`:@@hermes_country_sn:Senegal`,
    },
    {
        code: "RS",
        label: "Serbia",
        i18nLabel: $localize`:@@hermes_country_rs:Serbia`,
    },
    {
        code: "SC",
        label: "Seychelles",
        i18nLabel: $localize`:@@hermes_country_sc:Seychelles`,
    },
    {
        code: "SL",
        label: "Sierra Leone",
        i18nLabel: $localize`:@@hermes_country_sl:Sierra Leone`,
    },
    {
        code: "SG",
        label: "Singapore",
        i18nLabel: $localize`:@@hermes_country_sg:Singapore`,
    },
    {
        code: "SK",
        label: "Slovakia",
        i18nLabel: $localize`:@@hermes_country_sk:Slovakia`,
    },
    {
        code: "SI",
        label: "Slovenia",
        i18nLabel: $localize`:@@hermes_country_si:Slovenia`,
    },
    {
        code: "SB",
        label: "Solomon Islands",
        i18nLabel: $localize`:@@hermes_country_sb:Solomon Islands`,
    },
    {
        code: "SO",
        label: "Somalia",
        i18nLabel: $localize`:@@hermes_country_so:Somalia`,
    },
    {
        code: "ZA",
        label: "South Africa",
        i18nLabel: $localize`:@@hermes_country_za:South Africa`,
    },
    {
        code: "GS",
        label: "South Georgia and the South Sandwich Islands",
        i18nLabel: $localize`:@@hermes_country_gs:South Georgia and the South Sandwich Islands`,
    },
    {
        code: "LK",
        label: "Sri Lanka",
        i18nLabel: $localize`:@@hermes_country_lk:Sri Lanka`,
    },
    {
        code: "SD",
        label: "Sudan",
        i18nLabel: $localize`:@@hermes_country_sd:Sudan`,
    },
    {
        code: "SR",
        label: "Suriname",
        i18nLabel: $localize`:@@hermes_country_sr:Suriname`,
    },
    {
        code: "SJ",
        label: "Svalbard and Jan Mayen",
        i18nLabel: $localize`:@@hermes_country_sj:Svalbard and Jan Mayen`,
    },
    {
        code: "SZ",
        label: "Swaziland",
        i18nLabel: $localize`:@@hermes_country_sz:Swaziland`,
    },
    {
        code: "SE",
        label: "Sweden",
        i18nLabel: $localize`:@@hermes_country_se:Sweden`,
    },
    {
        code: "CH",
        label: "Switzerland",
        i18nLabel: $localize`:@@hermes_country_ch:Switzerland`,
    },
    {
        code: "SY",
        label: "Syrian Arab Republic",
        i18nLabel: $localize`:@@hermes_country_sy:Syrian Arab Republic`,
    },
    {
        code: "TJ",
        label: "Tajikistan",
        i18nLabel: $localize`:@@hermes_country_tj:Tajikistan`,
    },
    {
        code: "TZ",
        label: "Tanzania, United Republic of",
        i18nLabel: $localize`:@@hermes_country_tz:Tanzania, United Republic of`,
    },
    {
        code: "TH",
        label: "Thailand",
        i18nLabel: $localize`:@@hermes_country_th:Thailand`,
    },
    {
        code: "TL",
        label: "Timor-Leste",
        i18nLabel: $localize`:@@hermes_country_tl:Timor-Leste`,
    },
    {
        code: "TG",
        label: "Togo",
        i18nLabel: $localize`:@@hermes_country_tg:Togo`,
    },
    {
        code: "TK",
        label: "Tokelau",
        i18nLabel: $localize`:@@hermes_country_tk:Tokelau`,
    },
    {
        code: "TO",
        label: "Tonga",
        i18nLabel: $localize`:@@hermes_country_to:Tonga`,
    },
    {
        code: "TT",
        label: "Trinidad and Tobago",
        i18nLabel: $localize`:@@hermes_country_tt:Trinidad and Tobago`,
    },
    {
        code: "TN",
        label: "Tunisia",
        i18nLabel: $localize`:@@hermes_country_tn:Tunisia`,
    },
    {
        code: "TR",
        label: "Turkey",
        i18nLabel: $localize`:@@hermes_country_tr:Turkey`,
    },
    {
        code: "TM",
        label: "Turkmenistan",
        i18nLabel: $localize`:@@hermes_country_tm:Turkmenistan`,
    },
    {
        code: "TC",
        label: "Turks and Caicos Islands",
        i18nLabel: $localize`:@@hermes_country_tc:Turks and Caicos Islands`,
    },
    {
        code: "TV",
        label: "Tuvalu",
        i18nLabel: $localize`:@@hermes_country_tv:Tuvalu`,
    },
    {
        code: "UG",
        label: "Uganda",
        i18nLabel: $localize`:@@hermes_country_ug:Uganda`,
    },
    {
        code: "UA",
        label: "Ukraine",
        i18nLabel: $localize`:@@hermes_country_ua:Ukraine`,
    },
    {
        code: "AE",
        label: "United Arab Emirates",
        i18nLabel: $localize`:@@hermes_country_ae:United Arab Emirates`,
    },
    {
        code: "DH",
        label: "United Arab Emirates",
        i18nLabel: $localize`:@@hermes_country_ae:United Arab Emirates`,
    },
    {
        code: "GB",
        label: "United Kingdom",
        i18nLabel: $localize`:@@hermes_country_gb:United Kingdom`,
    },
    {
        code: "UK",
        label: "United Kingdom",
        i18nLabel: $localize`:@@hermes_country_gb:United Kingdom`,
    },
    {
        code: "US",
        label: "United States",
        i18nLabel: $localize`:@@hermes_country_us:United States`,
    },
    {
        code: "UM",
        label: "United States Minor Outlying Islands",
        i18nLabel: $localize`:@@hermes_country_um:United States Minor Outlying Islands`,
    },
    {
        code: "UY",
        label: "Uruguay",
        i18nLabel: $localize`:@@hermes_country_uy:Uruguay`,
    },
    {
        code: "UZ",
        label: "Uzbekistan",
        i18nLabel: $localize`:@@hermes_country_uz:Uzbekistan`,
    },
    {
        code: "VU",
        label: "Vanuatu",
        i18nLabel: $localize`:@@hermes_country_vu:Vanuatu`,
    },
    {
        code: "VE",
        label: "Venezuela, Bolivarian Republic of",
        i18nLabel: $localize`:@@hermes_country_ve:Venezuela, Bolivarian Republic of`,
    },
    {
        code: "VN",
        label: "Viet Nam",
        i18nLabel: $localize`:@@hermes_country_vn:Viet Nam`,
    },
    {
        code: "VG",
        label: "Virgin Islands, British",
        i18nLabel: $localize`:@@hermes_country_vg:Virgin Islands, British`,
    },
    {
        code: "VI",
        label: "Virgin Islands, U.S.",
        i18nLabel: $localize`:@@hermes_country_vi:Virgin Islands, U.S.`,
    },
    {
        code: "WF",
        label: "Wallis and Futuna",
        i18nLabel: $localize`:@@hermes_country_wf:Wallis and Futuna`,
    },
    {
        code: "EH",
        label: "Western Sahara",
        i18nLabel: $localize`:@@hermes_country_eh:Western Sahara`,
    },
    {
        code: "YE",
        label: "Yemen",
        i18nLabel: $localize`:@@hermes_country_ye:Yemen`,
    },
    {
        code: "ZM",
        label: "Zambia",
        i18nLabel: $localize`:@@hermes_country_zm:Zambia`,
    },
    {
        code: "ZW",
        label: "Zimbabwe",
        i18nLabel: $localize`:@@hermes_country_zw:Zimbabwe`,
    },
];

// AREACODES

export const areaCodes: { [key in CountryCode]: string } = {
    ae: "971",
    at: "43",
    au: "61",
    be: "32",
    br: "55",
    ca: "1",
    ch: "41",
    cn: "86",
    cz: "420",
    de: "49",
    dh: "971",
    dk: "45",
    es: "34",
    fi: "358",
    fr: "33",
    gr: "30",
    hk: "852",
    ie: "353",
    it: "39",
    jp: "81",
    kr: "82",
    lu: "352",
    mo: "853",
    mx: "52",
    my: "60",
    nl: "31",
    no: "47",
    pl: "48",
    pt: "351",
    ri: "966",
    sa: "966",
    se: "46",
    sg: "65",
    th: "66",
    tw: "886",
    us: "1",
    uk: "44",
};

// POSTCODE

type CountryCodePostalCode = CountryCode | "gb" | "nz";

/**
 * List of masks used for postcode inputs depending on regional specificities
 * where definitions are:
 * 0 - any digit
 * 9 - any optionnal digit
 * A - any letter and digit
 * S - any letter
 * to see more option check https://github.com/JsDaddy/ngx-mask/blob/develop/USAGE.md
 */
export const postcodeMasks: {
    [key in CountryCodePostalCode]: string;
} = {
    ae: "",
    at: "0000",
    au: "0000",
    be: "0000",
    br: "00000-000",
    ca: "AAA AAA",
    ch: "0000",
    cn: "000000",
    cz: "000 00",
    de: "00000",
    dh: "",
    dk: "0000",
    es: "00000",
    fi: "00000",
    fr: "00000",
    gr: "000 00",
    gb: "AA AAA||AAA AAA||AAAA AAA",
    hk: "",
    ie: "AAA AAAA",
    it: "00000",
    jp: "000-0000",
    kr: "00000",
    lu: "0000",
    mo: "",
    my: "00000",
    mx: "00000",
    nl: "AAAA AA",
    no: "0000",
    nz: "0000",
    pl: "00-000",
    pt: "0000||0000-000",
    ri: "00000 9999",
    sa: "00000 9999",
    se: "000 00",
    sg: "000000",
    th: "",
    tw: "000||000-000||000-00",
    uk: "AA AAA||AAA AAA||AAAA AAA",
    us: "00000",
};

export interface PostCode {
    separator?: string;
    pattern: string;
    maxLength: string;
    message?: string;
    delta?: string;
    digitsOnly?: boolean;
    zipBisMaxLength?: number;
    zipBisPattern?: string;
}

export interface AddressTemplate {
    address_display?: string;
    address_verification_fields?: string;
    address_verification_mapping?: string;
    address_verification_display?: string;
}

// ADDRESS
type AddressCountriesMappingType = Record<
    Uppercase<Exclude<CountryCode, "cn">> | "NZ",
    | {
          name?: { fields: string[] };
          company?: unknown;
          address?: Array<{
              fields: Array<keyof Address>;
              optional?: boolean;
          }>;
          postcode?: PostCode;
          template?: AddressTemplate;
      }
    | undefined
> &
    Record<
        "CN",
        {
            name: {
                en: { fields: Array<keyof Address> };
                zh: { fields: Array<keyof Address> };
            };
            company?: unknown;
            postcode?: PostCode;
            template: {
                en: AddressTemplate;
                zh: AddressTemplate;
            };
        }
    > &
    Record<
        "base",
        {
            name: { fields: Array<keyof Address> };
            company: unknown;
            postcode: PostCode;
            template: Omit<
                Required<AddressTemplate>,
                "address_verification_fields"
            > &
                AddressTemplate;
        }
    >;

export const addressCountriesMapping: AddressCountriesMappingType = {
    base: {
        name: {
            fields: ["prefix", "firstName", "middlename", "lastName"],
        },
        company: {
            fields: ["company"],
            optional: true,
        },
        template: {
            address_display:
                // eslint-disable-next-line sonarjs/no-duplicate-string
                "{{street1}}, {{street2}}, {{postcode}} {{city}}, {{countryId}}",
            address_verification_mapping: "{{street1}}, {{postcode}}, {{city}}",
            address_verification_display:
                "{{street1}}, {{street2}}, {{postcode}} {{city}}, {{countryId}}",
        },
        postcode: {
            pattern: ".*",
            maxLength: "5",
            message: "max",
            delta: "0",
        },
    },
    AE: undefined,
    AT: {
        template: {
            address_display:
                // eslint-disable-next-line sonarjs/no-duplicate-string
                "{{street1}}, {{street2}}, {{city}} {{region}} {{postcode}}, {{countryId}}",
            address_verification_mapping:
                // eslint-disable-next-line sonarjs/no-duplicate-string
                "{{street1}}, {{region}}, {{postcode}}, {{city}}",
            address_verification_display:
                "{{street1}}, {{street2}}, {{postcode}} {{city}}, {{countryId}}",
        },
        postcode: {
            pattern: String.raw`\d{5}`,
            maxLength: "5",
            message: "max",
            delta: "0",
            digitsOnly: true,
        },
    },
    AU: {
        template: {
            address_display:
                "{{street1}}, {{street2}}, {{city}} {{region}} {{postcode}}, {{countryId}}",
            address_verification_mapping:
                "{{street1}}, {{region}}, {{postcode}}, {{city}}",
            address_verification_display:
                "{{street1}}, {{street2}}, {{city}} {{region}} {{postcode}}, {{countryId}}",
        },
        postcode: {
            pattern: String.raw`\d{4}`,
            maxLength: "4",
            message: "max",
            delta: "0",
            zipBisMaxLength: 4,
            zipBisPattern: String.raw`\d{4}`,
            digitsOnly: true,
        },
    },
    BE: {
        postcode: {
            pattern: String.raw`\d{4}`,
            maxLength: "4",
            message: "max",
            delta: "0",
            digitsOnly: true,
        },
    },
    BR: {
        template: {
            address_display:
                "{{street1}}, {{streetNumber}}, {{street2}}, {{district}}, {{city}}, {{region}}, {{postcode}}, {{countryId}}",
            address_verification_fields:
                "{{street_address}}{{route}}, {{street_number}} - {{sublocality}}, {{administrative_area_level_2}} - {{administrative_area_level_1}}, {{postal_code}}",
            address_verification_mapping:
                "{{street1}}, {{streetNumber}} - {{district}}, {{city}} - {{regionLabel}}, {{postcode}}",
            address_verification_display:
                "{{street1}}, {{streetNumber}}, {{street2}} {{dash}} {{district}}, {{city}} - {{region}}, {{postcode}}, {{countryId}}",
        },
        postcode: {
            pattern: "([0-9]{5})([-]{1})([0-9]{3})",
            maxLength: "9",
            message: "max",
            delta: "0",
            separator: "-",
            digitsOnly: true,
        },
    },
    CA: {
        template: {
            address_display:
                "{{street1}}, {{street2}}, {{city}}, {{region}}, {{postcode}}, {{countryId}}",
            address_verification_mapping:
                "{{street1}}, {{region}}, {{postcode}}, {{city}}",
            address_verification_display:
                "{{street1}}, {{street2}}, {{city}}, {{region}}, {{postcode}}, {{countryId}}",
        },
        postcode: {
            pattern: ".*",
            maxLength: "5",
            message: "max",
            delta: "0",
        },
    },
    CH: {
        postcode: {
            pattern: String.raw`\d{4}`,
            maxLength: "4",
            message: "max",
            delta: "0",
            digitsOnly: true,
        },
    },
    CN: {
        name: {
            en: {
                fields: ["prefix", "lastName", "firstName"],
            },
            zh: {
                fields: ["lastName", "firstName", "prefix"],
            },
        },
        template: {
            en: {
                address_display:
                    "{{regionLabel}} {{city}} {{district}} {{street1}} {{countryId}}",
                address_verification_display:
                    "{{regionLabel}} {{city}} {{district}} {{street1}} {{countryId}}",
            },
            zh: {
                address_display:
                    "{{regionLabel}}{{city}}{{district}}{{street1}} {{countryId}}",
                address_verification_display:
                    "{{regionLabel}}{{city}}{{district}}{{street1}} {{countryId}}",
            },
        },
        postcode: {
            pattern: String.raw`\d{6}`,
            maxLength: "6",
            message: "max",
            delta: "0",
            digitsOnly: true,
        },
    },
    CZ: {
        template: {
            address_display:
                "{{street1}}, {{street2}}, {{postcode}}, {{city}}, {{countryId}}",
            address_verification_display:
                "{{street1}}, {{street2}}, {{postcode}}, {{city}}, {{countryId}}",
        },
        postcode: {
            pattern: "([0-9]{3})([ ]{1})([0-9]{2})",
            maxLength: "6",
            message: "max",
            delta: "0",
            separator: " ",
            digitsOnly: true,
        },
    },
    DE: {
        template: {
            address_display:
                "{{street1}}, {{street2}}, {{regionLabel}} {{postcode}} {{city}}, {{countryId}}",
            address_verification_mapping:
                "{{street1}}, {{regionLabel}}, {{postcode}}, {{city}}",
            address_verification_display:
                "{{street1}}, {{street2}}, {{postcode}} {{regionLabel}} {{city}}, {{countryId}}",
        },
        postcode: {
            pattern: String.raw`\d{5}`,
            maxLength: "5",
            message: "max",
            delta: "0",
            digitsOnly: true,
        },
    },
    DH: undefined,
    DK: {
        postcode: {
            pattern: "[0-9]{3,4}",
            maxLength: "4",
            message: "or",
            delta: "1",
            digitsOnly: true,
        },
    },
    ES: {
        postcode: {
            pattern: String.raw`\d{5}`,
            maxLength: "5",
            message: "max",
            delta: "0",
            digitsOnly: true,
        },
    },
    FI: {
        template: {
            address_display:
                "{{street1}}, {{street2}}, {{postcode}} {{city}}, {{countryId}}",
            address_verification_display:
                "{{street1}}, {{street2}}, {{postcode}} {{city}}, {{countryId}}",
        },
        postcode: {
            pattern: String.raw`\d{5}`,
            maxLength: "5",
            message: "max",
            delta: "0",
            digitsOnly: true,
        },
    },
    FR: {
        template: {
            address_display:
                // eslint-disable-next-line sonarjs/no-duplicate-string
                "{{street1}}, {{street2}}, {{city}} {{postcode}}, {{countryId}}",
        },
        postcode: {
            pattern: String.raw`\d{5}`,
            maxLength: "5",
            message: "max",
            delta: "0",
            digitsOnly: true,
        },
    },
    GR: {
        template: {
            address_display:
                // @TODO correct the format
                "{{street1}}, {{street2}}, {{city}} {{postcode}}, {{countryId}}",
        },
        postcode: {
            pattern: "([0-9]{3})([ ]{1})([0-9]{2})",
            maxLength: "6",
            message: "max",
            delta: "0",
            separator: " ",
            digitsOnly: true,
        },
    },
    UK: {
        template: {
            address_display:
                "{{street1}}, {{street2}}, {{city}} {{postcode}}, {{countryId}}",
            address_verification_mapping: "{{street1}}, {{city}}, {{postcode}}",
            address_verification_display:
                "{{street1}}, {{street2}}, {{city}} {{postcode}}, {{countryId}}",
        },
        postcode: {
            pattern: "([a-zA-Z0-9]{2,4})([ ]{1})([a-zA-Z0-9]{3})",
            maxLength: "8",
            message: "between",
            delta: "2",
            separator: " ",
        },
    },
    HK: {
        name: {
            fields: ["prefix", "firstName", "lastName"],
        },
        template: {
            address_display:
                "{{street1}}, {{street2}}, {{street3}}, {{regionLabel}}, {{district}}, {{city}}",
            address_verification_fields:
                "{{FloorNum}} {{UnitNo}}, {{buildingName}} {{PhaseNo}} {{BlockNo}}, {{buildingNoFrom}} {{buildingNoTo}} {{streetName}}, {{region}}",
            address_verification_mapping:
                "{{street1}}, {{street2}}, {{street3}}, {{region}}, {{district}}, {{city}}",
            address_verification_display:
                "{{street1}}, {{street2}}, {{street3}}, {{regionLabel}}, {{district}}, {{city}}",
        },
    },
    IE: {
        template: {
            address_verification_display:
                "{{street1}}, {{street2}}, {{city}} {{postcode}}, {{countryId}}",
        },
        postcode: {
            pattern: "[a-zA-Z0-9]{3}([ ]{1})[a-zA-Z0-9]{4}",
            maxLength: "8",
            message: "max",
            delta: "0",
            separator: " ",
            digitsOnly: true,
        },
    },
    IT: {
        template: {
            address_display:
                // eslint-disable-next-line sonarjs/no-duplicate-string
                "{{street1}}, {{street2}}, {{postcode}} {{region}} {{city}}, {{countryId}}",
            address_verification_mapping:
                "{{street1}}, {{region}}, {{postcode}}, {{city}}",
            address_verification_display:
                "{{street1}}, {{street2}}, {{postcode}} {{region}} {{city}}, {{countryId}}",
        },
        postcode: {
            pattern: String.raw`\d{5}`,
            maxLength: "5",
            message: "max",
            delta: "0",
            digitsOnly: true,
        },
    },
    JP: {
        name: {
            fields: ["lastName", "firstName", "lastName2", "firstName2"],
        },
        company: {
            fields: [],
            optional: true,
        },
        template: {
            address_display:
                "{{postcode}} {{blankLine}} {{regionLabel}}{{city}}{{street1}} {{street2}} {{countryId}}",
            address_verification_fields:
                "{{country}}, {{postal_code}} {{administrative_area_level_1}}{{locality}}{{sublocality_level_2}}",
            address_verification_mapping:
                "{{country}}, {{postcode}} {{regionLabel}}{{city}}{{street1}}{{street2}}",
            address_verification_display:
                "{{postcode}} {{regionLabel}}{{city}}{{street1}} {{street2}} {{countryId}}",
        },
        postcode: {
            pattern: String.raw`\d{7}`,
            maxLength: "7",
            message: "max",
            delta: "0",
            digitsOnly: true,
        },
    },
    KR: {
        name: {
            fields: ["lastName", "firstName"],
        },
        template: {
            address_display:
                "{{street2}} {{street1}} {{city}} {{postcode}} {{countryId}}",
        },
        postcode: {
            pattern: String.raw`\d{5}`,
            maxLength: "5",
            message: "max",
            delta: "0",
            digitsOnly: true,
        },
    },
    LU: {
        postcode: {
            pattern: String.raw`\d{4}`,
            maxLength: "4",
            message: "max",
            delta: "0",
            digitsOnly: true,
        },
    },
    MO: {
        name: {
            fields: ["prefix", "firstName", "lastName"],
        },
        template: {
            address_display:
                "{{street1}}, {{street2}}, {{street3}}, {{district}}, {{city}}, {{countryId}}",
            address_verification_fields:
                "{{street_number}} {{route}}, {{city}}, {{country}}",
            address_verification_mapping:
                "{{street1}}, {{street2}}, {{street3}}, {{city}}, {{country}}",
            address_verification_display:
                "{{street1}}, {{street2}}, {{street3}}, {{district}}, {{city}}, {{countryId}}",
        },
    },
    MX: {
        template: {
            address_display:
                "{{street1}}, {{streetNumber}}, {{additionalNumber}}, {{street2}}, {{neighborhood}}, {{district}}, {{postcode}}, {{city}}, {{regionLabel}}, {{countryId}}",
        },
        postcode: {
            pattern: String.raw`\d{5}`,
            maxLength: "5",
            message: "max",
            delta: "0",
            digitsOnly: true,
        },
    },
    MY: {
        template: {
            address_display:
                "{{street1,?}}, {{street2}}, {{postcode}}, {{city}}, {{regionLabel}}, {{countryId}}",
            address_verification_fields:
                "{{street_number}}, {{route}}, {{sublocality}}, {{postal_code}} {{locality}}, {{administrative_area_level_1}}, {{country}}",
            address_verification_mapping:
                "{{streetNumber}}, {{street1}}, {{district}}, {{postcode}} {{city}}, {{regionLabel}}, {{country}}",
            address_verification_display:
                "{{street1,?}}, {{street2}}, {{postcode}}, {{city}}, {{regionLabel}}, {{countryId}}",
        },
        postcode: {
            pattern: String.raw`\d{5}`,
            maxLength: "5",
            message: "max",
            delta: "0",
            digitsOnly: true,
        },
    },
    NL: {
        postcode: {
            pattern:
                "(^[a-zA-Z0-9]{4}$)|(^[a-zA-Z0-9]{4})([ ]{1})([a-zA-Z0-9]{2}$)",
            maxLength: "7",
            message: "or",
            delta: "2",
            separator: " ",
            digitsOnly: true,
        },
    },
    NO: {
        postcode: {
            pattern: String.raw`\d{4}`,
            maxLength: "4",
            message: "max",
            delta: "0",
            digitsOnly: true,
        },
    },
    NZ: {
        template: {
            address_display:
                "{{street1}}, {{street2}}, {{city}} {{postcode}}, {{countryId}}",
        },
        postcode: {
            pattern: String.raw`\d{4}`,
            maxLength: "4",
            message: "max",
            delta: "0",
            zipBisMaxLength: 4,
            zipBisPattern: String.raw`\d{4}`,
            digitsOnly: true,
        },
    },
    PL: {
        template: {
            address_display:
                "{{street1}}, {{street2}}, {{postcode}} {{region}} {{city}}, {{countryId}}",
            address_verification_mapping:
                "{{street1}}, {{region}}, {{postcode}}, {{city}}",
            address_verification_display:
                "{{street1}}, {{street2}}, {{postcode}} {{region}} {{city}}, {{countryId}}",
        },
        postcode: {
            pattern: "([0-9]{2})([-]{1})([0-9]{3})",
            maxLength: "6",
            message: "max",
            delta: "0",
            separator: "-",
            digitsOnly: true,
        },
    },
    PT: {
        postcode: {
            pattern:
                "(^[a-zA-Z0-9]{4}$)|(^[a-zA-Z0-9]{4})([-]{1})([a-zA-Z0-9]{3}$)",
            maxLength: "8",
            message: "or",
            delta: "3",
            separator: "-",
            digitsOnly: true,
        },
    },
    RI: {
        template: {
            address_display:
                "{{street1}}, {{street2}}, {{city}} {{postcode}}, {{countryId}}",
        },
        postcode: {
            pattern: "([0-9]{5,9}$)",
            maxLength: "10",
            message: "between",
            delta: "2",
            separator: " ",
        },
    },
    SA: {
        template: {
            address_display:
                "{{street1}}, {{street2}}, {{city}} {{postcode}}, {{countryId}}",
        },
        postcode: {
            pattern: "([0-9]{5,9}$)",
            maxLength: "10",
            message: "between",
            delta: "2",
            separator: " ",
        },
    },
    SE: {
        template: {
            address_display:
                "{{street1}}, {{street2}}, {{city}} {{postcode}}, {{countryId}}",
        },
        postcode: {
            pattern: "([0-9]{3})([ ]{1})([0-9]{2})",
            maxLength: "6",
            message: "max",
            delta: "0",
            separator: " ",
            digitsOnly: true,
        },
    },
    SG: {
        template: {
            address_display:
                "{{street1}}, {{street2}}, {{city}}, {{postcode}}, {{countryId}}",
            address_verification_fields:
                "{{street_number}} {{route}}, {{locality}}, {{postal_code}}",
            address_verification_mapping: "{{street1}}, {{city}}, {{postcode}}",
            address_verification_display:
                "{{street1}}, {{street2}}, {{city}}, {{postcode}}, {{countryId}}",
        },
        postcode: {
            pattern: ".*",
            maxLength: "7",
            message: "max",
            delta: "0",
        },
    },
    TH: {
        name: {
            fields: ["prefix", "firstName", "lastName"],
        },
        template: {
            address_display:
                "{{street1}}, {{street2}}, {{regionLabel}}, {{district}}, {{postcode}}",
            address_verification_fields:
                "{{route}}, {{sublocality_level_2}}, {{sublocality_level_1}}, {{administrative_area_level_1}} {{postal_code}}, {{country}}",
            address_verification_mapping:
                "{{street1}} {{street2}}, {{district}}, {{region}} {{postcode}}, {{countryId}}",
            address_verification_display:
                "{{street1}}, {{street2}}, {{regionLabel}}, {{district}}, {{postcode}}",
        },
    },
    TW: {
        name: {
            fields: ["lastName", "firstName", "prefix"],
        },
        company: {
            fields: ["company"],
            optional: false,
        },
        template: {
            address_display:
                "{{postcode}} {{city}} {{district}} {{street1}}, {{street2}}, {{countryId}}",
            address_verification_fields:
                "{{postal_code}}{{administrative_area_level_1}}{{administrative_area_level_3}}{{route}}{{streetNumber}}",
            address_verification_mapping:
                "{{postcode}}{{city}}{{district}}{{street1}}",
            address_verification_display:
                "{{postcode}} {{city}} {{district}} {{street1}}, {{street2}}, {{countryId}}",
        },
        postcode: {
            pattern: String.raw`(\d{3}\-\d{3})|(\d{3}[-]\d{2})|(\d{3})`,
            maxLength: "7",
            message: "between",
            separator: "-",
        },
    },
    US: {
        template: {
            address_display:
                "{{street1}}, {{street2}}, {{city}} {{region}} {{postcode}} {{postcodeBis}}, {{countryId}}",
            address_verification_mapping:
                "{{street1}}, {{city}} {{region}} {{postcode}}",
            address_verification_display:
                "{{street1}}, {{street2}}, {{city}} {{region}} {{postcode}} {{postcodeBis}}, {{countryId}}",
        },
        postcode: {
            pattern: String.raw`\d{5}`,
            maxLength: "5",
            message: "max",
            delta: "0",
            zipBisMaxLength: 4,
            zipBisPattern: String.raw`\d{4}`,
            digitsOnly: true,
        },
    },
};
